<mat-select [attr.cy-select]="ngControl?.name" [(value)]="value" [placeholder]="displayValue || 'Selecciona un rango'"
  [panelClass]="panelClass" class="rex-date-range" #matSelect
  (openedChange)="handleSelection($event)"
  [ngClass]="{'selected-value': value}">

  <mat-select-trigger>
    <mat-icon>keyboard_arrow_right</mat-icon>
    Fecha
  </mat-select-trigger>

  <mat-option disabled class="mat-option-date-range">
    <div class="container-options-date-range">
      <mat-list class="options-default">
        @for (option of dateRangeOptions; track option.description) {
          <mat-list-item class="date-range-option" (click)="option.function()">
            {{option.description}}
          </mat-list-item>
        }
      </mat-list>
      @if (showCustomMonth) {
      <div class="options-datepicker">
        <div class="calendar-left">
          <div class="calendar-header-left">
            <button matIconButton class="calendar-header-navigation calendar-header-navigation-left" (click)="previousClicked()">
              <mat-icon>keyboard_arrow_left</mat-icon>
            </button>
            <span>{{ startDateLeft | date: 'MMMM yyyy' : 'America/Lima': 'es-ES' | capitalize }}</span>
          </div>
          <mat-calendar #calendarLeft [maxDate]="maxDate" [startAt]="startDateLeft" [selected]="selected"
            (selectedChange)="onDateSelected($event)">
          </mat-calendar>
        </div>
        <div class="calendar-rigth">
          <div class="calendar-header-right">
            <span>{{ startDateRigth | date: 'MMMM yyyy' : 'America/Lima': 'es-ES' | capitalize }}</span>
            <button matIconButton class="calendar-header-navigation calendar-header-navigation-right" (click)="nextClicked()">
              <mat-icon>keyboard_arrow_right</mat-icon>
            </button>
          </div>
          <mat-calendar #calendarRigth [maxDate]="maxDate" [startAt]="startDateRigth" [selected]="selected"
            (selectedChange)="onDateSelected($event)">
          </mat-calendar>
        </div>


      </div>
      }
    </div>
  </mat-option>
</mat-select>
